var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceAtom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 188,
    viewBox: "0 0 209 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6697 150.537L102.136 81.2699L27.7946 87.9359",
    stroke: "#263238",
    strokeWidth: 2.3576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9959 134.159C93.7678 129.398 104.942 132.569 109.952 141.247C114.962 149.925 111.909 160.818 103.137 165.58C94.3647 170.341 83.1909 167.17 78.1806 158.492C73.1704 149.814 76.224 138.921 84.9959 134.159Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.12 135.564C97.6094 135.546 102.984 138.406 105.895 143.449",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4589 68.7155C29.8235 63.0895 43.0255 66.8363 48.9451 77.0892C54.8646 87.3422 51.257 100.213 40.8924 105.839C30.5278 111.465 17.3258 107.719 11.4063 97.4656C5.48675 87.2127 9.09434 74.3415 19.4589 68.7155Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1784 70.2903C34.6335 70.2779 40.95 73.6205 44.3824 79.5654",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.801 17.6475C145.449 14.0387 153.919 16.4417 157.717 23.0198C161.515 29.5979 159.2 37.8548 152.551 41.4636C145.903 45.0724 137.433 42.6694 133.636 36.0913C129.838 29.5132 132.153 21.2563 138.801 17.6475Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.805 18.8278C147.994 18.8183 152.112 20.9843 154.344 24.851",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3172 61.0952C99.0663 54.1749 115.305 58.784 122.586 71.3949C129.867 84.0057 125.43 99.8377 112.681 106.758C99.9316 113.678 83.6929 109.069 76.412 96.4584C69.1311 83.8475 73.5681 68.0155 86.3172 61.0952Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4363 62.9338C105.343 62.9161 113.088 67.028 117.284 74.2941",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceAtom1);
export default __webpack_public_path__ + "static/media/price-atom-1.f703d9ae3b76df85264801ac1845996c.svg";
export { ForwardRef as ReactComponent };